import i18next from 'i18next';
import { AllowedDepartment } from '../../@types/boosters';
import { getBrandAndHotelData } from '../../../helpers/handleBrandAndHotelData';
import { getInitialHotelSelectionData } from '../../../helpers/hotelSelectorHelpers';
import Analytics from '../../../utils/analytics';
import { getItem } from '../../../utils/localStorage';

export const BOOSTER_ANALYTICS_EVENTS = {
  STARTED: 'BOOSTERS: BOOSTER STARTED',
  COMPLETED: 'BOOSTERS: BOOSTER COMPLETED',
  TOPIC_COMPLETED: 'BOOSTERS: TOPIC COMPLETED',
} as const;

const DEPARTMENT_TRANSLATION_KEYS: Record<AllowedDepartment, string> = {
  [AllowedDepartment.FRONT_OF_HOUSE]: 'COMMON.LEARNING.TITLES.FRONT_OF_HOUSE',
  [AllowedDepartment.FOOD_BEVERAGE]: 'COMMON.LEARNING.TITLES.FOOD_AND_BEVERAGE',
  [AllowedDepartment.HOUSEKEEPING]: 'COMMON.LEARNING.TITLES.HOUSEKEEPING',
  [AllowedDepartment.PRODUCT]: 'COMMON.LEARNING.TITLES.PRODUCT',
};

export function getDepartmentLabel (department: AllowedDepartment): string {
  return i18next.t(DEPARTMENT_TRANSLATION_KEYS[department]);
}

export function getBoosterEventProperties (department: AllowedDepartment) {
  const userData = getItem('user');
  const allHotels = getBrandAndHotelData() || [];
  const { brandName, hotelName } = getInitialHotelSelectionData(allHotels);

  return {
    userId: userData && userData.user && userData.user.id,
    brandName,
    hotelName,
    department: getDepartmentLabel(department),
  };
}

export function trackBoosterEvent (
  eventName: string,
  department: AllowedDepartment
) {
  Analytics.sendEvent(eventName, getBoosterEventProperties(department));
}
